import { render, staticRenderFns } from "./askDialog.vue?vue&type=template&id=355830af&"
import script from "./askDialog.vue?vue&type=script&lang=js&"
export * from "./askDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports